import Alpine from "alpinejs";
import './js/viewport';
import './js/audio';
import './js/panzoom';
import './js/nav';
Alpine.start();
